import { createContext } from 'react';
import type { RefObject } from 'react';
import type { ImageModalRef } from '../organisms/image-modal/ImageModal.data';

export interface SiteContextType {
  imageModalRef?: RefObject<ImageModalRef | null>;
}

export const SiteContext = createContext<SiteContextType | undefined>(undefined);
